export default "__VITE_ASSET__BAYQRfxA__"